













































import { typedStore } from '@/store';
import Vue from 'vue';

export default Vue.extend({
  name: 'RulesCard',
  props: {
    items: Array as () => any[],
    collapsible: Boolean,
  },
  data() {
    return {
      swiperOptions: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      showMore: false,
    };
  },
  computed: {
    isLargeScreen(): boolean {
      return typedStore(this as any).state.rules.largeScreen;
    },
    isToggleButtonShown(): boolean {
      return this.items.length > 5;
    },
    shownItems(): any[] {
      return this.collapsible
        && !this.showMore
        && this.isToggleButtonShown
        && this.isLargeScreen
        ? this.items.slice(0, 5)
        : this.items;
    },
  },
});
